import * as React from 'react';

import './social-account/social-account.scss';

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {SocialAccount}      from "./social-account/social-account";
import {SocialAccountMeta}  from './social-account/social-account-meta';

export const SocialAccounts = ({socialMediaStatus, agentId}) => cs(
    consumeContext("apis"),
    ({apis}) => (
        <div className="social-accounts-CaSiO3">
            {socialMediaStatus.facebook && (
                SocialAccountMeta({
                    getAccount: () => apis.next.social.getFbSocial({agentId}),
                    removeAccount: () => apis.next.social.removeFbSocial({agentId}),
                    getLoginUrl: (account) => account?.value?.data?.fb_account?.login_url ?? account?.value?.login_url,
                    isLoggedIn: (account) => account?.value?.action,
                    getUserLabel: (account) => account?.value?.data?.fb_account?.name,
                    getPages: (account) => account?.value?.data?.fb_pages,
                })
            )}
            {socialMediaStatus.twitter && (
                SocialAccount({
                    platformLabel: "X",
                    icon: "assets/x-icon-white.svg",
                    getAccount: () => apis.next.social.getTwSocial({agentId}),
                    removeAccount: () => apis.next.social.removeTwSocial({agentId}),
                    getLoginUrl: (account) => account?.value?.tw_account?.login_url,
                    isLoggedIn: (account) => account?.value?.action,
                    getUserLabel: (account) => account?.value?.tw_account?.name,
                })
            )}

            {socialMediaStatus.linkedin && (
                SocialAccount({
                    platformLabel: "Linkedin",
                    icon: "assets/linkedin-icon-dark.png",
                    getAccount: () => apis.next.social.getLiSocial({agentId}),
                    removeAccount: () => apis.next.social.removeLiSocial({agentId}),
                    getLoginUrl: (account) => account?.value?.li_account?.login_url,
                    isLoggedIn: (account) => account?.value?.action,
                    getUserLabel: (account) => account?.value?.li_account?.name,
                })
            )}
        </div>
    ),
);